import { v4 as uuidv4 } from 'uuid';
import AuthModule from '@modules/AuthModule';
import { getCorrectedNow } from '@modules/ServiceModule/workspace/lib/clientServerTimeDiff';
import { WebphoneCallState } from '@modules/SoftPhoneModule/types';
import { UserActionDeviceType, UserActionEventType } from '../lib/types';
import { UserActionEventTable } from '../lib/UserActionEventTable';
import IAppLogger from '@app/lib/IAppLogger';

/**
 * Writes an AgentHoldEnded event to IndexedDB when the agent resumes a held call.
 * Timestamp is corrected for client/server clock skew via getCorrectedNow().
 */
const handleAgentHoldEnded = async (
  callState: WebphoneCallState,
  table: UserActionEventTable,
  logger: IAppLogger,
): Promise<void> => {
  const userId = AuthModule.user?.id;
  if (!userId) return;

  const kazooCallId = callState.remoteCallId;
  if (!kazooCallId) {
    logger.warn(
      'IndexDbModule: handleAgentHoldEnded — callState missing remoteCallId, skipping event write',
    );
    return;
  }

  const timestamp = getCorrectedNow();

  try {
    await table.add({
      eventId: uuidv4(),
      kazooCallId,
      event: UserActionEventType.AgentHoldEnded,
      timestamp,
      deviceType: UserActionDeviceType.Web,
      userId,
    });
  } catch (error) {
    logger.error('IndexDbModule: failed to write AgentHoldEnded event', error);
  }
};

export default handleAgentHoldEnded;
